import { render, staticRenderFns } from "./Edge.vue?vue&type=template&id=4b2bfd85&scoped=true&"
import script from "./Edge.vue?vue&type=script&lang=ts&"
export * from "./Edge.vue?vue&type=script&lang=ts&"
import style0 from "./Edge.vue?vue&type=style&index=0&id=4b2bfd85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2bfd85",
  null
  
)

export default component.exports